import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loadScript } from "../../../../globals/constants";
import SectionFaqGeneral from "../../public-user/sections/faq/section-faq-general";
import SectionFaqJobs from "../../public-user/sections/faq/section-faq-jobs";
import SectionFaqPayments from "../../public-user/sections/faq/section-faq-payment";
import SectionFaqReturn from "../../public-user/sections/faq/section-faq-return";
import { fetchDashboard } from "../../../../reducers/candidate/CanDashboardSlice";
import { fetchGeneralAds } from "../../../../reducers/public-user/adsSlice";

const CanFaqPage = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.CanDashboard.loading);
  const ads = useSelector((state) => state.ads.ads);
  const userUUID = useSelector((state) => state.AuthStatus.userUUID);

  useEffect(() => {
    loadScript("js/custom.js");
    if (loading === true) dispatch(fetchDashboard(userUUID));
  }, [dispatch]);

  useEffect(() => {
    if (loading === true) dispatch(fetchGeneralAds());
  }, [dispatch]);

  return (
    <div>
      <div className="wt-admin-right-page-header clearfix">
        <div className="row">
          <div className="col-xl-4 col-lg-12 col-md-12 mb-4">
            <h2>FAQ</h2>
            <div className="breadcrumbs">
              <a>Home</a>
              <a>Dashboard</a>
              <span>FAQ</span>
            </div>
          </div>
          <div className="col-xl-8 col-lg-12 col-md-12 mb-4">
            <NavLink to={ads?.FAQ_Header_Link} target="_blank">
              <img
                src={ads?.FAQ_Header}
                alt="Banner Image"
                className="img-fluid"
              />
            </NavLink>
          </div>
        </div>
      </div>

      <div className="panel panel-default site-bg-white m-t30">
        <div className="panel-heading p-a20">
          <h4 className="panel-tittle m-a0">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#General"
                  type="button"
                  role="tab"
                  style={{ color: "#39ce6d" }}
                >
                  Health Professionals
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#Jobs"
                  type="button"
                  role="tab"
                  aria-controls="Jobs"
                  style={{ color: "#39ce6d" }}
                >
                  Business
                </button>
              </li> */}
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#Payment"
                  type="button"
                  role="tab"
                  aria-controls="Payment"
                  style={{ color: "#39ce6d" }}
                >
                  Employers
                </button>
              </li> */}
              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#Return"
                  type="button"
                  role="tab"
                  aria-controls="Return"
                  style={{ color: "#39ce6d" }}
                >
                  Return
                </button>
              </li> */}
            </ul>
          </h4>
        </div>

        <div className="twm-tabs-style-1 center p-t30">
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="General"
              role="tabpanel"
            >
              <SectionFaqGeneral />
            </div>
            <div className="tab-pane fade" id="Jobs" role="tabpanel">
              <SectionFaqJobs />
            </div>
            <div className="tab-pane fade" id="Payment" role="tabpanel">
              <SectionFaqPayments />
            </div>
            {/* <div className="tab-pane fade" id="Return" role="tabpanel">
              <SectionFaqReturn />
            </div> */}
          </div>
        </div>
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 mb-4 mt-5">
        <NavLink to={ads?.FAQ_Footer_Link} target="_blank">
          <img src={ads?.FAQ_Footer} alt="Banner Image" className="img-fluid" />
        </NavLink>
      </div>
    </div>
  );
};

export default CanFaqPage;
